import React from "react";
import { Navigate, Route, useLocation } from "react-router-dom";

import { useSessionStatus } from "../hooks/useSessionStatus";
import SessionLoader from "../components/Common/SessionLoader";
import {
  clearLocalSession,
  SESSION_CHECKING,
  SESSION_VALID,
} from "../helpers/sessionValidation";

const AuthProtected = (props) => {
  const location = useLocation();
  // Etat de la session : "checking" | "valid" | "invalid".
  // Aucun contenu authentifie n'est rendu tant que le serveur n'a pas confirme
  // la validite du token (evite l'affichage fugitif du tableau de bord lors de
  // l'ouverture de l'application avec une session expiree).
  const sessionStatus = useSessionStatus();

  // Changement de mot de passe obligatoire non termine :
  // interdire l'acces aux pages authentifiees (ex: /home), meme via le bouton
  // "Precedent" du navigateur. On deconnecte l'utilisateur et on le renvoie
  // vers /login tant que le mot de passe n'a pas ete change.
  const mustChangePassword =
    localStorage.getItem("passwordChange") === "true";

  if (mustChangePassword) {
    clearLocalSession();
    return <Navigate to="/login" replace />;
  }

  // 1. Validation en cours -> ecran de chargement neutre (pas de layout).
  if (sessionStatus === SESSION_CHECKING) {
    return <SessionLoader />;
  }

  // 2. Session expiree ou absente -> redirection directe vers /login.
  if (sessionStatus !== SESSION_VALID) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // 3. Session confirmee valide -> affichage de la plateforme.
  return <>{props.children}</>;
};

const AccessRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        return (<> <Component {...props} /> </>);
      }}
    />
  );
};

export { AuthProtected, AccessRoute };
